import {
  GET_WELCOME_APP_SUCEESS,
  CLOSE_POP,
  IS_OPEN_WELCOME_POP,
  IS_CUSTOMER_CLICK,
  CHANGE_CHECK_STATUS,
} from '../constants/welcomePopUp';

const initState = {
  isOpen: true,
  dateNum: null,
  needShow: null,
  isCustomerClick: 1,
  welcomeAppList: [],
};

const WelcomApp = (state = initState, action = {}) => {
  let soft = {};
  let tempList = [];
  switch (action.type) {
    case GET_WELCOME_APP_SUCEESS:
      return {
        ...state,
        welcomeAppList: action.payload,
        needShow: action.judgeValue,
        dateNum: action.dateNum,
      };
    case IS_OPEN_WELCOME_POP:
      return { ...state, isOpen: action.visible };
    case IS_CUSTOMER_CLICK:
      return { ...state, isCustomerClick: action.visible };
    case CLOSE_POP:
      return { ...state, isOpen: false };
    case CHANGE_CHECK_STATUS:
      soft = state.welcomeAppList.find(v => v.softID === action.softID);
      soft.isChecked = !soft.isChecked;
      tempList = [...state.welcomeAppList];
      return { ...state, welcomeAppList: tempList };
    default:
      return state;
  }
};

export default WelcomApp;
